<template>
  <div class="table">
    <van-row class="header" :wrap="false">
      <van-col class="left" span="11">
        <div class="float">{{ lang('运单编码') }}</div>
        <div v-if="props.list.length > 0" class="shadow"></div>
      </van-col>
      <van-col span="11"></van-col>
      <van-col span="10">{{ lang('寄件日期') }}</van-col>
      <van-col span="10">{{ lang('入库日期') }}</van-col>
      <van-col class="right" span="10">{{ lang('提成金额') }}</van-col>
      <van-col class="right" span="8">{{ lang('总运费') }}</van-col>
    </van-row>
    <van-row
      v-for="(item, i) in props.list"
      :key="i"
      class="list"
      :wrap="false"
    >
      <van-col class="value left" span="11">
        <div class="float">
          <CopyButton :text="item[0]" :index="i" />
        </div>
        <div class="shadow"></div>
      </van-col>
      <van-col class="value" span="11"></van-col>
      <van-col class="value" span="10">{{ item[1] || '-' }}</van-col>
      <van-col class="value" span="10">{{ item[2] || '-' }}</van-col>
      <van-col class="value right" span="10">{{ item[3] || '-' }}</van-col>
      <van-col class="value right" span="8">{{ item[4] || '-' }}</van-col>
    </van-row>
  </div>
</template>

<script lang="ts" setup>
import lang from '../../../langs'
import CopyButton from '@/components/CopyButton.vue'

const props = defineProps({
  list: {
    // 下拉区域始终为全屏的高度
    type: Array,
    default: () => []
  }
})
</script>

<style scoped lang="less">
.table {
  padding: 17px 0;
  background: #fff;
  color: #3c3c3c;
  overflow: scroll;
  .float {
    flex: 1;
    align-items: center;
    padding: 12px 0;
    position: relative;
    z-index: 111;
    background: #fff;
  }
  .header {
    background: #fff;
  }
  .list {
    //padding: 12px 0;
    //border-top: 1px solid #f7f7f7;
    background: #fff;
  }
  :deep(.van-col) {
    text-align: center;
    padding: 12px 0;
    font-size: 13px;
    background: #fff;
    width: 100%;
    .value {
      font-size: 11px;
    }
  }
  .right {
    text-align: right;
    padding-right: 20px;
  }
  .left {
    text-align: left;
    position: absolute;
    display: flex;
    padding: 0 0 0 20px;
    .shadow {
      width: 1px;
      display: flex;
      flex-direction: column;
      box-shadow: 0 0 22px 2px rgba(0, 0, 0, 0.1);
      padding: 12px 0;
    }
  }
}
</style>
